import WithIconNotificationSection from '@/components/molecules/notification-section/WithIconNotificationSection.vue'
import WithTitleNotificationSection from '@/components/molecules/notification-section/WithTitleNotificationSection.vue'
import Vue, { VueConstructor } from 'vue'

export type NotificationLevel = 'alert' | 'caution'

export interface WithTitleLayout {
  type: 'with-title'
  title: string
  body: string
}
export interface WithIconLayout {
  type: 'with-icon'
  body: string
}
export type NotificationLayout = WithTitleLayout | WithIconLayout

export const noNotificationView = Vue.extend({
  name: 'NoNotificationView',
  template: '<div style="display: none;"></div>',
})

const isWithTitleLayout = (layout: NotificationLayout): layout is WithTitleLayout =>
  layout.type === 'with-title'
const isWithIconLayout = (layout: NotificationLayout): layout is WithIconLayout =>
  layout.type === 'with-icon'

export class NotificationSectionViewFactory {
  static create<T extends NotificationLayout>(
    level: NotificationLevel,
    layout: T
  ): VueConstructor {
    if (isWithIconLayout(layout)) {
      return Vue.extend({
        components: { WithIconNotificationSection },
        template: `
          <with-icon-notification-section level="${level}">
            <template v-slot:body>${layout.body}</template>
          </with-icon-notification-section>
        `,
      })
    }
    if (isWithTitleLayout(layout)) {
      return Vue.extend({
        components: { WithTitleNotificationSection },
        template: `
          <with-title-notification-section level="${level}" title="${layout.title}">
            <template v-slot:body>${layout.body}</template>
          </with-title-notification-section>`,
      })
    }

    return noNotificationView
  }
}
